import { ALL_LOB } from '../constants'

const getRouteId = (id?: string | string[]) => (Array.isArray(id) ? id[0] : id)

export const getExclusionsBasePath = (connectorId: string) =>
  connectorId === ALL_LOB ? '/dashboard/exclusions' : '/exclusions'

export const getExclusionsRouteForConnector = ({
  connectorId,
  currentPath,
  id,
}: {
  connectorId: string
  currentPath: string
  id?: string | string[]
}) => {
  const isExclusionsRoute =
    currentPath === '/exclusions' ||
    currentPath.startsWith('/exclusions/') ||
    currentPath === '/dashboard/exclusions' ||
    currentPath.startsWith('/dashboard/exclusions/')

  if (!isExclusionsRoute) {
    return null
  }

  const routeId = getRouteId(id)
  const basePath = getExclusionsBasePath(connectorId)

  return routeId ? `${basePath}/${routeId}` : basePath
}
